import styled from 'styled-components';
import { Flex, Text, TextProps, FlexProps } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { CSSProperties } from 'react';

const StyledUserInitalsBadge = styled(Flex)<FlexProps>`
	background-color: ${({ theme }) => theme.v3.colors.gray[4]};
	color: ${({ theme }) => theme.v3.colors.dark[8]};
	padding: 0.25rem;
	border-radius: 50%;
`;

const DEFAULT_USER_BADGE_SIZE = '1.5rem';

export const UserInitialsBadge = ({
	firstName,
	lastName,
	size,
	textVariant,
}: {
	firstName?: string;
	lastName?: string;
	size?: CSSProperties['height'];
	textVariant?: TextProps['fz'];
}) => {
	const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`;
	return (
		<StyledUserInitalsBadge
			align="center"
			justify="center"
			h={size || DEFAULT_USER_BADGE_SIZE}
			miw={size || DEFAULT_USER_BADGE_SIZE}
		>
			{initials.length ? (
				<Text fz={textVariant} fw={500} tt="uppercase" style={{ lineHeight: 1 }}>
					{initials}
				</Text>
			) : (
				<Icon variant="user" size="lg" />
			)}
		</StyledUserInitalsBadge>
	);
};
